import { LabItem } from "./types"

// export const BASE_URL = 'https://us-central1-arcaentretenimento.cloudfunctions.net/api/'
export const BASE_URL = 'https://lab.arcaentretenimento.com.br/api/'


export function roundValor(valor:number){
    return((Math.ceil(valor*100)/100).toFixed(2))
}

export const months = ['Janeiro','Fevereiro','Março','Abril','Maio','Junho','Julho','Agosto','Setembro','Outubro','Novembro','Dezembro'
]

export const inputStyle =(width=''):any=> {
        if(!width){
          width = '100%'
        }
        return(
            {
        backgroundColor:'#1b1b1b',
        padding:'12px',
        boxSizing:'border-box',
        border:'2px solid #393939',
        outline:'none',
        borderRadius:'10px',
        color:'#fff',
        width:width,
            })
    }
    
export const inputStyleInvalid = (width='')=> {
      if(!width){
        width = '100%'
      }
        return({
      backgroundColor:'#1b1b1b',
      padding:'12px',
      border:'2px solid #ff5733',
      outline:'none',
      borderRadius:'10px',
      color:'#fff',
      width:width,
      boxSizing:'border-box'
    })
  }
    export const inputStyle2 =(width='400px')=> {
        return({
        backgroundColor:'#1b1b1b',
        border:'2px solid #393939',
        outline:'none',
        borderRadius:'5px 0 0 5px',
        color:'#fff',
        height:'20px',
        width:width,
    })
    }

    export const UFs = [
  "AC", "AL", "AP", "AM", "BA", "CE", "DF", "ES", "GO", "MA",
  "MT", "MS", "MG", "PA", "PB", "PR", "PE", "PI", "RJ", "RN",
  "RS", "RO", "RR", "SC", "SP", "SE", "TO"
];

export const error_messages:any = {
  WRONG_USER: 'E-mail ou senha não encontrados.',
  EMAIL_USED: 'Este e-mail já está cadastrado.'
}

export const authentication_error_messages: Record<string, string> = {
  // Login e Signup
  "auth/invalid-email": "E-mail inválido.",
  "auth/user-disabled": "Esta conta foi desativada.",
  "auth/user-not-found": "Usuário não encontrado.",
  "auth/wrong-password": "Senha incorreta.",
  "auth/too-many-requests": "Muitas tentativas falhas. Tente novamente mais tarde.",
  "auth/network-request-failed": "Erro de conexão. Verifique sua internet.",

  // Signup específico
  "auth/email-already-in-use": "Este e-mail já está cadastrado.",
  "auth/weak-password": "A senha deve conter pelo menos 6 caracteres.",

  // Outros casos genéricos que podem aparecer
  "auth/invalid-credential": "Credenciais inválidas.",
  "auth/internal-error": "Erro interno. Tente novamente.",
  "auth/operation-not-allowed": "Método de login não está habilitado.",
};

export function checkLabSoldout(lab:LabItem, online:boolean){
    if(online){
        if(lab.current_online===lab.max_online){
            return(true)
        }
    } else {
        if(lab.current_presencial===lab.max_presencial){
            return(true)
        }
    }
  return(false)
}